import { useState } from "react";

export const PASSWORD_MIN_LEN = 8;

export function usePasswordForm() {
  const [cur, setCur] = useState("");
  const [novo, setNovo] = useState("");
  const [conf, setConf] = useState("");

  const rules = [
    { key: "minLen", ok: novo.length >= PASSWORD_MIN_LEN, text: `Mínimo ${PASSWORD_MIN_LEN} caracteres` },
    { key: "letter", ok: /[a-zA-Z]/.test(novo), text: "Pelo menos 1 letra" },
    { key: "digit", ok: /\d/.test(novo), text: "Pelo menos 1 número" },
    { key: "match", ok: Boolean(novo && conf && novo === conf), text: "As duas novas senhas conferem" },
    { key: "different", ok: Boolean(cur && novo && cur !== novo), text: "Nova senha diferente da atual" },
  ];
  const canSubmit = Boolean(cur) && rules.every((r) => r.ok);

  const reset = () => { setCur(""); setNovo(""); setConf(""); };

  return { cur, setCur, novo, setNovo, conf, setConf, rules, canSubmit, reset };
}
